import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { API } from 'aws-amplify';

@Component({
  selector: 'app-rental-refi-form',
  templateUrl: './rental-refi-form.component.html',
  styleUrls: ['./rental-refi-form.component.scss'],
  providers: [MessageService]
})
export class RentalRefiFormComponent implements OnInit {
  runningNumbers: boolean = false;
  yesno: any[];
  propertyTypes: any[];
  wasRehabCompletedAfterPurch: any;
  hasBeenListedInLast6Months: any;
  propertyType: any;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  interestedProperty: string;
  interestedCity: string;
  interestedState: string;
  interestedZip: string;
  ficoScore: number;
  estimatedAsIs: number;
  grossRents: number;
  annualHOA: number;
  annualFlood: number;
  annualTaxes: number;
  annualHazard: number;
  dateOfPurchase: string;
  payoff: number;
  rentalsInLast36Months: number;
  propertiesOwnedFlipped36Months: number;
  originalPurchasePrice: number;
  rehabBudget: number;
  actualRehabSpend: number;
  referralSource: string;

  constructor(private messageService: MessageService) { 
    this.yesno = [
      {name: 'Yes', code: 'Yes'},
      {name: 'No', code: 'No'}
    ];

    this.propertyTypes = [
      {name: 'Single', code: 'Single'},
      {name: 'Multi-Family up to 4 Units', code: 'MultiUpTo4'},
      {name: 'Multi-Family 4 to 20 Units', code: 'Multi4To20'}
    ];
  }

  ngOnInit(): void {
  }

  async runRentalRefiNumbers() {
    this.runningNumbers = true;
    this.messageService.clear();
    if (!this.wasRehabCompletedAfterPurch ||
      !this.referralSource ||
      !this.hasBeenListedInLast6Months ||
      !this.propertyType ||
      !this.firstName ||
      !this.lastName ||
      !this.phone ||
      !this.email ||
      !this.interestedProperty ||
      !this.interestedCity ||
      !this.interestedState ||
      !this.interestedZip ||
      !this.ficoScore ||
      !this.estimatedAsIs ||
      !this.grossRents ||
      !this.annualHOA ||
      !this.annualFlood ||
      !this.annualTaxes ||
      !this.annualHazard ||
      !this.dateOfPurchase ||
      !this.payoff ||
      !this.rentalsInLast36Months ||
      !this.propertiesOwnedFlipped36Months ||
      !this.originalPurchasePrice ||
      (this.wasRehabCompletedAfterPurch.name == 'Yes' && (!this.rehabBudget || !this.actualRehabSpend))) {
        this.messageService.add({severity: 'warn', summary: 'Required Fields Missing', detail: 'Please fill out all required fields'});
        this.messageService.add({key: 'tst', severity: 'warn', summary: 'Required Fields Missing', detail: 'Please fill out all required fields'});
        this.runningNumbers = false;
        return;
      }

      if (this.ficoScore < 640) {
        console.log(this.ficoScore);
        this.messageService.add({severity: 'error', summary: 'FICO Score', detail: 'Your FICO score is below our requirements'});
        this.messageService.add({key: 'tst', severity: 'error', summary: 'FICO Score', detail: 'Your FICO score is below our requirements'});
      }
      else if (this.containsOnlyNumbers(this.ficoScore) == false || this.containsOnlyNumbers(this.estimatedAsIs) == false ||
               this.containsOnlyNumbers(this.grossRents) == false || this.containsOnlyNumbers(this.annualHOA) == false ||
               this.containsOnlyNumbers(this.annualFlood) == false || this.containsOnlyNumbers(this.annualTaxes) == false ||
               this.containsOnlyNumbers(this.annualHazard) == false || this.containsOnlyNumbers(this.payoff) == false ||
               this.containsOnlyNumbers(this.rentalsInLast36Months) == false || this.containsOnlyNumbers(this.propertiesOwnedFlipped36Months) == false ||
               this.containsOnlyNumbers(this.originalPurchasePrice) == false) {
        this.messageService.add({severity: 'error', summary: 'Number Validation Error', detail: 'Check your number inputs contain only whole numbers'});
      }
      else {
        //Form is valid send it
        const params = {
          body: {
            wasRehabCompletedAfterPurch: this.wasRehabCompletedAfterPurch.name,
            hasBeenListedInLast6Months: this.hasBeenListedInLast6Months.name,
            propertyType: this.propertyType.name,
            firstName: this.firstName,
            lastName: this.lastName,
            phone: this.phone,
            email: this.email,
            interestedProperty: this.interestedProperty,
            interestedCity: this.interestedCity,
            interestedState: this.interestedState,
            interestedZip: this.interestedZip,
            ficoScore: this.ficoScore,
            estimatedAsIs: this.estimatedAsIs,
            grossRents: this.grossRents,
            annualHOA: this.annualHOA,
            annualFlood: this.annualFlood,
            annualTaxes: this.annualTaxes,
            annualHazard: this.annualHazard,
            dateOfPurchase: this.dateOfPurchase,
            payoff: this.payoff,
            rentalsInLast36Months: this.rentalsInLast36Months,
            propertiesOwnedFlipped36Months: this.propertiesOwnedFlipped36Months,
            originalPurchasePrice: this.originalPurchasePrice,
            rehabBudget: this.rehabBudget,
            actualRehabSpend: this.actualRehabSpend,
            referralSource: this.referralSource
          }
        }

        var response = await API.post('ckpublicapi', '/api/run-my-rental-refi-numbers', params);

        if (response.success) {
          this.messageService.add({key: 'tst', severity: 'success', summary: 'Thank You!', detail: 'Your numbers have been submitted and you will hear from us soon'});
          this.clearVariables();
        }
        else {
          this.messageService.add({severity: 'error', summary: 'Error', detail: response.message});
        }
      }

      this.runningNumbers = false;
  }

  containsOnlyNumbers(str) {
    return /^\d+$/.test(str.trim());
  }

  clearVariables() {
    this.wasRehabCompletedAfterPurch = null;
    this.hasBeenListedInLast6Months = null;
    this.propertyType = null;
    this.firstName = null;
    this.lastName = null;
    this.phone = null;
    this.email = null;
    this.interestedProperty = null;
    this.interestedCity = null;
    this.interestedState = null;
    this.interestedZip = null;
    this.ficoScore = null;
    this.estimatedAsIs = null;
    this.grossRents = null;
    this.annualHOA = null;
    this.annualFlood = null;
    this.annualTaxes = null;
    this.annualHazard = null;
    this.dateOfPurchase = null;
    this.payoff = null;
    this.rentalsInLast36Months = null;
    this.propertiesOwnedFlipped36Months = null;
    this.originalPurchasePrice = null;
    this.rehabBudget = null;
    this.actualRehabSpend = null;
    this.referralSource = null;
  }

}
